export default {
  'center': {
    'common': {
      'search': 'Buscar',
      'reset': 'Restablecer',
      'submit': 'Enviar',
      'cancel': 'Cancelar',
      'confirm': 'Confirmar',
      'operation': 'Operación',
      'status': 'Estado',
      'createTime': 'Hora de Creación',
      'updateTime': 'Hora de Actualización',
      'remark': 'Observación',
      'amount': 'Monto',
      'currency': 'Moneda',
      'orderNumber': 'Número de Pedido',
      'memberAccount': 'Cuenta de Miembro',
      'fee': 'Tarifa',
      'type': 'Tipo',
      'all': 'Todos',
      'pending': 'Pendiente',
      'processing': 'Procesando',
      'completed': 'Completado',
      'failed': 'Fallido',
      'rejected': 'Rechazado',
      'approved': 'Aprobado',
      'locked': 'Bloqueado',
      'unlocked': 'Desbloqueado',
      'dateRange': 'Rango de Fechas',
      'startDate': 'Fecha de Inicio',
      'endDate': 'Fecha de Fin',
      'dateType': 'Tipo de Fecha',
      'dateType.createTime': 'Hora de Creación',
      'dateType.updateTime': 'Hora de Actualización',
      'dateType.completeTime': 'Hora de Finalización',
      'dateType.applyTime': 'Hora de Solicitud',
      'dateType.successTime': 'Hora de Finalización',
      'noData': 'Sin Datos',
      'startAmount': 'Monto Mínimo',
      'endAmount': 'Monto Máximo'
    },
    'withdrawal': {
      'title': 'Gestión de Órdenes de Retiro',
      'config': {
        'title': 'Configuración de Retiro',
        'basic': {
          'title': 'Configuración Básica de Retiro',
          'minAmount': 'Monto Mínimo de Retiro',
          'maxAmount': 'Monto Máximo de Retiro',
          'dailyLimit': 'Límite Diario de Retiro',
          'monthlyLimit': 'Límite Mensual de Retiro',
          'feeRate': 'Tarifa de Comisión',
          'feeType': 'Tipo de Tarifa',
          'feeTypes': {
            'fixed': 'Monto Fijo',
            'percentage': 'Porcentaje'
          }
        },
        'risk': {
          'title': 'Configuración de Control de Riesgo',
          'ipLimit': 'Límite de IP',
          'deviceLimit': 'Límite de Dispositivo',
          'locationLimit': 'Límite de Ubicación',
          'riskLevel': 'Nivel de Riesgo',
          'riskLevels': {
            'low': 'Bajo',
            'medium': 'Medio',
            'high': 'Alto'
          }
        }
      },
      'order': {
        'title': 'Órdenes de Retiro',
        'status': {
          'pending': 'Pendiente de Revisión',
          'processing': 'Procesando',
          'completed': 'Completado',
          'failed': 'Fallido',
          'rejected': 'Rechazado',
          'waiting': 'Esperando Pago',
          'paid': 'Pagado',
          'dfProcessing': 'Procesando Pago',
          'locked': 'Pago Bloqueado',
          'riskLocked':'Bloqueado en revisión'
        },
        'type': {
          'bank': 'Transferencia Bancaria',
          'crypto': 'Criptomoneda',
          'other': 'Otro',
          'BANK': 'Tarjeta Bancaria',
          'ALIPAY': 'Alipay',
          'WECHAT': 'WeChat',
          'USDT': 'USDT'
        },
        'action': {
          'approve': 'Aprobar',
          'reject': 'Rechazar',
          'lock': 'Bloquear',
          'unlock': 'Desbloquear',
          'detail': 'Detalles',
          'confirm': 'Confirmar Pago',
          'paid': 'Procesar Pago',
          'rejectWithdraw': 'Rechazar Retiro',
          'frontRemark': 'Observación del Frontend',
          'backRemark': 'Observación del Backend',
          'dfFailReason': 'Razón de Fallo de Pago',
          'updateChannel': 'Actualizar Canal de Pago',
          'adminUnlock': 'Desbloqueo de Administrador'
        },
        'info': {
          'orderNumber': 'Número de Pedido',
          'memberAccount': 'Cuenta de Miembro',
          'currency': 'Moneda de Retiro',
          'amount': 'Información de Monto',
          'withdrawAmount': 'Monto de Retiro',
          'fee': 'Tarifa',
          'realAmount': 'Monto Real',
          'withdrawMethod': 'Método de Retiro',
          'operationInfo': 'Información de Operación',
          'applyTime': 'Hora de Solicitud',
          'riskCheckTime': 'Hora de Verificación de Riesgo',
          'riskCheckOperator': 'Operador de Verificación de Riesgo',
          'successTime': 'Hora de Pago',
          'successOperator': 'Operador de Pago',
          'channelName': 'Canal de Pago',
          'refuseTime': 'Hora de Rechazo',
          'refuseOperator': 'Operador de Rechazo',
          'timeProgress': 'Progreso de Tiempo de Retiro',
          'status': 'Estado',
          'remark': 'Observación',
          'manualOperation': 'Retiro manual',
          'withdrawShowInfo':'Información de retiro',
          'showInfoBankAccount':'Nombre de titular de tarjeta bancaria',
          'showInfoBankNumber':'Número de tarjeta bancaria',
          'showInfoBankName':'Nombre de banco',
          'showInfoUSDTAccount':'Dirección USDT',
          'showInfoUSDTRate':'Tasa de cambio USDT',
          'showInfoUSDTType':'Tipo de cadena USDT',
          'showInfoRealName':'Nombre',
          'showInfoAccount':'Número de cuenta',
          'showInfoRealAmount':'Monto de pago',
          'showInfoCurSign':'Moneda',
          'clickCreateOrderTime': 'Miembro hizo clic en retiro',
          'receiveServerTime': 'Servidor recibió solicitud',
          'financialOperatorTime': 'Finanzas procesó retiro',
          'externalReceiveTime': 'Devolución de llamada de terceros completada',
          'systemGeneratedOrder': 'Orden generada por sistema',
        },
        'modal': {
          'reject': {
            'title': 'Rechazar Retiro',
            'frontRemark': 'Observación del Frontend',
            'backRemark': 'Observación del Backend',
            'confirm': 'Confirmar',
            'cancel': 'Cancelar',
            'success': 'Rechazo exitoso',
            'failed': 'Error al rechazar'
          },
          'confirm': {
            'title': 'Confirmar Pago',
            'content': '¿Está seguro de que desea confirmar el pago?',
            'confirm': 'Confirmar',
            'cancel': 'Cancelar',
            'success': 'Confirmación de pago exitosa',
            'failed': 'Error en confirmación de pago',
            '70016015':'El monto no cumple con el monto mínimo del canal',
            '70016016':'El monto excede el monto máximo del canal',
            '70018018':'La configuración del parámetro del canal es anormal, por favor verifique',
            '70015065':'El pago para esta orden de retiro falló. Por favor intente otros canales de pago',
            '70015073':'Este registro se está procesando. Por favor no repita la operación',
            '70015017':'El pago en nombre de miembros requiere verificación de identidad real',
            '70015076':'Por favor verifique el estado de orden más reciente',
          },
          'paid': {
            'title': 'Procesar Pago',
            'channel': 'Canal de Pago',
            'selectChannel': 'Seleccione un canal de pago',
            'confirm': 'Confirmar',
            'cancel': 'Cancelar',
            'success': 'Procesamiento de pago exitoso',
            'failed': 'Error en procesamiento de pago'
          },
          'remark': {
            'title': 'Información de Observación',
            'frontRemark': 'Observación del Frontend',
            'backRemark': 'Observación del Backend',
            'close': 'Cerrar'
          },
          'updateChannel': {
            'title': 'Actualizar Canal de Pago',
            'channel': 'Canal de Pago',
            'selectChannel': 'Seleccione un canal de pago',
            'confirm': 'Confirmar',
            'cancel': 'Cancelar',
            'success': 'Actualización de canal de pago exitosa',
            'failed': 'Error en actualización de canal de pago'
          }
        }
      }
    },
    'recharge': {
      'title': 'Gestión de Órdenes de Recarga',
      'config': {
        'title': 'Configuración de Recarga',
        'channel': {
          'title': 'Configuración del Canal de Recarga',
          'name': 'Nombre del Canal',
          'currency': 'Tipo de Moneda',
          'platform': 'Tipo de Plataforma',
          'status': 'Estado',
          'statuses': {
            'enabled': 'Habilitado',
            'disabled': 'Deshabilitado'
          }
        }
      },
      'order': {
        'title': 'Orden de Recarga',
        'info': {
          'orderNumber': 'Número de Pedido',
          'memberAccount': 'Cuenta de Miembro',
          'paymentChanneName':'Nombre del Canal',
          'currency': 'Moneda',
          'amount': 'Monto',
          'fee': 'Tarifa',
          'realAmount': 'Monto Real',
          'status': 'Estado del Pedido',
          'createTime': 'Hora de Creación',
          'payTime': 'Hora de Pago',
          'orderSource': 'Fuente de Pedido',
          'platform': 'Método de Pago',
          'dateType': 'Tipo de Fecha',
          'dateRange': 'Rango de Fechas',
          'startDate': 'Fecha de Inicio',
          'endDate': 'Fecha de Fin',
          'paymentMethod': 'Método de Pago',
          'successTime': 'Hora de Éxito',
          'successOperator':'Operador',
          'remark': 'Observación',
          'timeInfo': 'Información de Tiempo',
          'showOvertimeOnly': 'Mostrar Solo Órdenes Fuera de Tiempo',
          'memberOrderTime': 'Hora de Pedido del Miembro',
          'paymentSuccessTime': 'Hora de Éxito de Pago',
          'timeDetails': {
            't0': 'T0 Pedido de Clic',
            't1': 'T1 Solicitud de Pedido',
            't2': 'T2 Generar Pedido',
            't3': 'T3 Devoluciones de Terceros',
            't3_5': 'T3.5 Retorno al Frontend',
            't4': 'T4 Redirigir a Pagar',
            't5': 'T5 Respuesta de Devolución de Llamada',
            'memberPaying': '🟢 Miembro pagando',
            'paymentTimeout': '🔴 Tiempo de espera del enlace de pago: T3.5-T0 = {time}',
            'expandFullLink': 'Expandir Enlace Completo',
            'collapseFullLink': 'Contraer Enlace Completo'
          },
        },
        'source': {
          'H5': 'H5',
          'IOS': 'IOS',
          'ANDROID': 'ANDROID'
        },
        'status': {
          'pending': 'Pendiente',
          'processing': 'Procesando',
          'completed': 'Completado',
          'failed': 'Fallido',
          'rejected': 'Rechazado',
          'waiting': 'Esperando',
          'paid': 'Pagado',
          'dfProcessing': 'Procesando Pago',
          'locked': 'Bloqueado',
          'expired':'Vencido',
          'invalid':'Inválido'
        },
        'action': {
          'approve': 'Aprobar',
          'reject': 'Rechazar',
          'confirm': 'Confirmar',
          'detail': 'Detalle',
          'export': 'Exportar'
        },
        'modal': {
          'approve': {
            'title': 'Aprobar Orden de Recarga',
            'remark': 'Observación'
          },
          'reject': {
            'title': 'Rechazar Orden de Recarga',
            'reason': 'Razón de Rechazo',
            'remark': 'Observación'
          },
          'confirm': {
            'title': 'Confirmar Orden de Recarga',
            'content': '¿Confirmar que esta orden de recarga ha sido recibida?',
            'confirm': 'Confirmar',
            'cancel': 'Cancelar'
          }
        }
      }
    },
    'payment': {
      'title': 'Configuración de Pago',
      'channel': {
        'title': 'Configuración de Canal de Pago',
        'name': 'Nombre del Canal',
        'code': 'Código del Canal',
        'type': 'Tipo de Canal',
        'status': 'Estado',
        'config': 'Configuración',
        'action': {
          'add': 'Agregar Canal',
          'edit': 'Editar Canal',
          'delete': 'Eliminar Canal',
          'enable': 'Habilitar',
          'disable': 'Deshabilitar'
        }
      }
    },
    // Callback Whitelist
    callbackWhitelist: {
      title: 'Lista blanca de devoluciones',
      type: {
        label: 'Tipo',
        placeholder: 'Seleccione tipo',
        all: 'Todo',
        pay: 'Pago',
        withdraw: 'Retiro'
      },
      component: {
        label: 'Nombre del canal',
        placeholder: 'Ingrese nombre del canal'
      },
      ip: {
        label: 'Dirección IP',
        placeholder: 'Ingrese dirección IP',
        formatError: 'Ingrese un formato de dirección IP válido',
        example: 'Ingrese dirección IP, p. ej.: 192.168.1.1'
      },
      createTime: 'Fecha de creación',
      createUser: 'Creado por',
      action: {
        search: 'Buscar',
        reset: 'Restablecer',
        add: 'Añadir IP a lista blanca',
        delete: 'Eliminar',
        deleteConfirm: '¿Está seguro de que desea eliminar este registro de lista blanca?',
        deleteSuccess: 'Eliminado exitosamente',
        deleteFailed: 'Error al eliminar',
        addSuccess: 'Añadido exitosamente',
        addFailed: 'Error al añadir'
      },
      modal: {
        addTitle: 'Añadir IP a lista blanca',
        type: {
          label: 'Tipo',
          placeholder: 'Seleccione tipo',
          required: 'Seleccione tipo'
        },
        component: {
          label: 'Selección de canal',
          placeholder: 'Seleccione canal',
          required: 'Seleccione canal'
        },
        ip: {
          label: 'Dirección IP',
          placeholder: 'Ingrese dirección IP, p. ej.: 192.168.1.1',
          required: 'Ingrese dirección IP',
          formatError: 'Ingrese un formato de dirección IP válido'
        },
        confirm: 'Confirmar',
        cancel: 'Cancelar'
      }
    },
    paymentSettings: {
      title: 'Configuración de pagos',
      channel: {
        title: 'Canal de pago',
        search: {
          channelName: 'Nombre del canal',
          channelNamePlaceholder: 'Ingrese nombre del canal',
          paymentGroup: 'Grupo de pago',
          paymentGroupPlaceholder: 'Seleccione grupo de pago',
          paymentModel: 'Método de pago',
          paymentModelPlaceholder: 'Seleccione método de pago',
          currency: 'Tipo de moneda',
          currencyPlaceholder: 'Seleccione tipo de moneda',
          status: 'Estado',
          statusPlaceholder: 'Seleccione estado',
          statusEnabled: 'Habilitado',
          statusDisabled: 'Deshabilitado',
          search: 'Buscar',
          button: 'Buscar',
          reset: 'Restablecer'
        },
        table: {
          channelName: 'Nombre del canal',
          paymentGroup: 'Grupo de pago',
          paymentModel: 'Método de pago',
          payDescription: 'Descripción del canal',
          currency: 'Moneda',
          platformType: 'Tipo de plataforma',
          minAmount: 'Monto mínimo',
          maxAmount: 'Monto máximo',
          amountRange:'Rango de monto',
          agentOverride: 'Sobrescritura de agente',
          default: 'Por defecto',
          memberLevel:'Nivel de miembro',
          agentConfig: 'Configuración de agente',
          agentConfigNotSet: 'No configurado',
          agentConfigAll: 'Todos los agentes',
          agentConfigPartial: 'Agentes específicos',
          agentConfigSet: 'Configurado',
          agentConfigOverride: 'Sobrescritura de agente · Reglas de monto',
          agentConfigNote: 'Otros agentes/usuarios regulares: Usar configuración global; Prioridad: Configuración de agente > Configuración global.',
          status: 'Estado',
          sort:'Ordenar',
          action: 'Acción',
          edit: 'Editar',
          params: 'Parámetros',
          delete: 'Eliminar'
        },
        modal: {
          add: 'Añadir canal de pago',
          edit: 'Editar canal de pago',
          delete: {
            title: 'Confirmar eliminación',
            content: '¿Está seguro de que desea eliminar este canal de pago?'
          }
        },
        form: {
          paymentGroup: 'grupo de pago',
          paymentGroupPlaceholder: 'Seleccione grupo de pago',
          paymentGroupAll:'Todo',
          paymentGroupOnline:'Pago en línea',
          paymentGroupOffline:'Pago sin conexión',
          paymentModel: 'Método de pago',
          paymentModelPlaceholder: 'Seleccione método de pago',
          channel: 'Selección de canal',
          channelPlaceholder: 'Seleccione canal',
          channelName:'Nombre del canal',
          channelNamePlaceholder:'Ingrese nombre del canal',
          currency: 'Tipo de moneda',
          currencyPlaceholder: 'Seleccione tipo de moneda',
          platformType: 'Tipo de plataforma',
          platformTypePlaceholder: 'Seleccione tipo de plataforma',
          paymentPlatformAll:'Todo',
          paymentPlatformPC:'Terminal PC',
          paymentPlatformH5:'Terminal H5',
          minAmount: 'Monto mínimo',
          minAmountPlaceholder: 'Ingrese monto mínimo',
          maxAmount: 'Monto máximo',
          maxAmountPlaceholder: 'Ingrese monto máximo',
          depositStairs:'Condiciones de acumulación',
          depositStairsPlaceholder:'Ingrese condiciones de depósito acumulado',
          amountType:'tipo de monto',
          amountTypePlaceholder:'Seleccione el tipo de monto',
          amountTypeSelect:'monto fijo',
          amountTypeWrite:'ingresar monto',
          amountTypeAll:'todos admitidos',
          amountList:'lista de montos',
          amountListPlaceholder:'Ingrese lista de montos, separados por coma',
          defaultAmount: 'Monto por defecto',
          defaultAmountPlaceholder: 'Ingrese monto por defecto',
          amountListInRangeError: 'Los valores en la lista de montos deben estar entre el monto mínimo y máximo',
          defaultAmountInListError: 'El monto por defecto debe incluirse en la lista de montos cuando se usan montos fijos',
          memberLevel:'Nivel de miembro',
          memberLevelPlaceholder:'Seleccione un nivel de miembro',
          memberLevelAll:'Todos los niveles',
          walletAccount: 'Cuenta de billetera',
          walletAccountPlaceholder: 'Ingrese una cuenta de billetera',
          walletName: 'Nombre de usuario de billetera',
          walletNamePlaceholder: 'Ingrese nombre de usuario de billetera',
          payTag:'Observaciones',
          payTagPlaceholder:'Ingrese observaciones',
          payDescription: 'Descripción del canal',
          payDescriptionPlaceholder: 'Ingrese descripción del canal',
          sort:'Ordenar',
          sortPlaceholder:'Ingrese orden',
          needMemberName:'¿Necesita nombre real?',
          needMemberName1:'Sí',
          needMemberName2:'No',
          usdtAccount:'Dirección USDT',
          usdtAccountPlaceholder:'Ingrese dirección USDT',
          usdtType:'Tipo USDT',
          usdtTypePlaceholder:'Seleccione tipo USDT',
          usdtRate:'Tasa de cambio USDT',
          usdtRatePlaceholder:'Ingrese tasa de cambio USDT',
          usdtRateType:'Tipo de tasa de cambio USDT',
          usdtRateTypeFixed:'Tasa de cambio fija',
          usdtRateTypeFloat:'Tasa de cambio flotante',
          bankName:'Nombre del banco',
          bankNamePlaceholder:'Ingrese nombre del banco',
          bankAccount:'Cuenta de tarjeta de banco',
          bankAccountPlaceholder:'Ingrese cuenta de tarjeta de banco',
          bankNumber:'Número de tarjeta de banco',
          bankNumberPlaceholder:'Ingrese número de tarjeta de banco',
          bankAddress:'Dirección del banco',
          bankAddressPlaceholder:'Ingrese dirección del banco',
          accountName:'Nombre de cuenta',
          accountNamePlaceholder:'Ingrese nombre de cuenta',
          qrCode: 'Código QR',
          qrCodeUpload: 'Cargar código QR',
          qrCodeTip: 'Cargue imagen de código QR',
          agentSelect: 'Selección de agente (Buscable · Múltiple)',
          agentSearchPlaceholder: 'Buscar cuenta de agente...',
          allAgents: 'Todos los agentes',
          unknown: 'Desconocido',
          agentConfig: 'Configuración de agente (Sobrescribir monto global)',
          agentConfigNote: '(Contraído por defecto, configurar solo cuando sea necesario)',
          agentConfigValidation: 'Validación: Mín ≤ Máx; El monto por defecto debe estar dentro del rango; Cuando se usa monto fijo, el "monto por defecto" debe incluirse en la lista de montos; Los valores en la lista de montos deben estar dentro del rango.',
          agentConfigDisabled: 'La configuración de agente está deshabilitada, habilite el interruptor para configurar reglas de agente',
          status: 'Estado',
          // Agent configuration validation messages
          agentSelectRequired: 'Seleccione agente',
          loading: 'Cargando...',
          noData: 'Sin datos',
          minAmountRequired: 'El monto mínimo no puede estar vacío',
          maxAmountRequired: 'El monto máximo no puede estar vacío',
          minAmountError: 'El monto mínimo debe ser menor que el monto máximo',
          maxAmountError: 'El monto máximo debe ser mayor que el monto mínimo',
          defaultAmountError: 'El monto por defecto debe estar entre el monto mínimo y máximo',
          amountListRequired: 'La lista de montos es requerida cuando el tipo de monto es fijo',
          // Common messages
          missingDataId: 'Falta identificador de datos requerido, no se puede actualizar registro',
          updateSuccess: 'Actualización exitosa',
          addSuccess: 'Añadido exitosamente',
          updateFailed: 'Error al actualizar',
          addFailed: 'Error al añadir',
          formValidationFailed: 'Validación de formulario fallida',
          formValidationFailedCheck: 'Validación de formulario fallida, verifique el contenido ingresado',
          operationFailed: 'Operación fallida, intente de nuevo',
          fetchAgentListFailed: 'Error al obtener lista de agentes'
        },
        param: {
          title: 'Configuración de parámetros',
          merchantId: 'ID de comerciante',
          merchantKey: 'Clave de comerciante',
          apiUrl: 'URL de API',
          notifyUrl: 'URL de notificación',
          remark: 'Observación',
          alipayAppId: 'ID de app Alipay',
          alipayPrivateKey: 'Clave privada Alipay',
          alipayPublicKey: 'Clave pública Alipay',
          wxAppId: 'ID de app WeChat',
          wxMchId: 'ID de comerciante WeChat',
          wxApiKey: 'Clave de API WeChat',
          gatewayUrl: 'URL de puerta de enlace',
          returnUrl: 'URL de retorno',
          signType: 'Tipo de firma',
          version: 'Versión',
          required: 'Ingrese campo requerido',
          fetchError: 'Error al obtener lista de parámetros',
          saveSuccess: 'Guardado exitosamente',
          saveError: 'Error al guardar'
        }
      },
      method: {
        title: 'Método de pago',
        search: {
          "statusAll": "Todos",
          paymentMethodName: 'Nombre del método de pago',
          paymentMethodNamePlaceholder: 'Ingrese nombre del método de pago',
          curSign: 'Tipo de moneda',
          curSignPlaceholder: 'Seleccione tipo de moneda',
          paymentType: 'Tipo de pago',
          paymentTypePlaceholder: 'Seleccione tipo de pago',
          status: 'Estado',
          statusPlaceholder: 'Seleccione estado',
          statusEnabled: 'Habilitado',
          statusDisabled: 'Deshabilitado',
          button: 'Buscar',
          reset: 'Restablecer'
        },
        table: {
          paymentGroup: 'Grupo de pago',
          paymentModel: 'Método de pago',
          currency: 'Tipo de moneda',
          platformType: 'Tipo de plataforma',
          platformTypeAll: 'Todo',
          platformTypePC: 'PC',
          platformTypeH5: 'H5',
          logo: 'Logo de icono',
          sort: 'Ordenar',
          status: 'Estado',
          action: 'Acción',
          edit: 'Editar',
          delete: 'Eliminar'
        },
        modal: {
          add: 'Añadir método de pago',
          edit: 'Editar método de pago',
          delete: {
            title: 'Confirmar eliminación',
            content: '¿Está seguro de que desea eliminar este método de pago?'
          },
          success: {
            create: 'Creado exitosamente',
            update: 'Actualizado exitosamente',
            createFailed: 'Error al crear',
            updateFailed: 'Error al actualizar'
          }
        },
        form: {
          "defaultPlaceholder": "Seleccione",
          basicInfo: 'Información básica',
          paymentGroup: 'Grupo de pago',
          paymentGroupPlaceholder: 'Seleccione grupo de pago',
          paymentGroupAll: 'Todos los grupos',
          paymentGroupOnline: 'Pago en línea',
          paymentGroupOffline: 'Pago sin conexión',
          currency: 'Moneda',
          currencyPlaceholder: 'Seleccione moneda',
          paymentModel: 'Método de pago',
          paymentModelPlaceholder: 'Ingrese método de pago',
          paymentModelName: 'Nombre del método de pago',
          paymentModelNamePlaceholder: 'Ingrese nombre del método de pago',
          paymentShowName:'nombre de visualización del método de pago',
          paymentShowNamePlaceholder:'Ingrese nombre de visualización del método de pago',
          payTag:'etiqueta de método de pago',
          payTagPlaceholder:'Ingrese etiqueta de método de pago',
          platformType: 'Tipo de plataforma',
          platformTypePlaceholder: 'Seleccione tipo de plataforma',
          platformTypeAll: 'Todo',
          platformTypePC: 'PC',
          platformTypeH5: 'H5',
          sort: 'Ordenar',
          sortPlaceholder: 'Ingrese orden',
          iconSettings: 'Configuración de icono',
          pcLogo: 'Logo de PC',
          h5Logo: 'Logo de H5',
          otherInfo: 'Otra información',
          remark: 'Observación',
          remarkPlaceholder: 'Ingrese observación',
          confirm: 'Confirmar',
          cancel: 'Cancelar'
        },
        error: {
          unknownType: 'Tipo de selección desconocido:',
          fetchOptionsFailed: 'Error al obtener las opciones de {type}:'
        }
      },
      withdrawalSettings: {
        withdrawalMethod: {
          button: {
            edit: 'Editar',
            delete: 'Eliminar'
          }
        }
      }
    },
    'withdrawalSettings': {
      'withdrawalMethod': {
        'title': 'Configuración de método de retiro',
        'search': {
          'searchKeyword': 'Nombre de tipo',
          'searchKeywordPlaceholder': 'Ingrese nombre de tipo',
          'status': 'Estado',
          'statusPlaceholder': 'Seleccione estado',
          'statusAll': 'Todo',
          'statusEnabled': 'Habilitado',
          'statusDisabled': 'Deshabilitado',
          'curSign': 'Moneda',
          'curSignPlaceholder': 'Seleccione moneda',
          'button': 'Buscar',
          'reset': 'Restablecer'
        },
        'table': {
          'typeName': 'Tipo de retiro',
          'showName': 'Nombre de retiro',
          'showRemark': 'Sugerencia de interfaz',
          'logoPic':'Icono de visualización',
          'logoPicPC':'Icono de terminal PC',
          'logoPicH5':'Icono de terminal H5',
          'amountRange':'Rango de monto',
          'curSign': 'Moneda',
          'minAmount': 'Monto mínimo',
          'maxAmount': 'Monto máximo',
          'overAmount': 'Monto excedido',
          'fee': 'Comisión',
          'sort': 'Ordenar',
          'status': 'Estado',
          'updateInfo': 'Información de actualización',
          'action': 'Acción'
        },
        'modal': {
          'add': 'Añadir método de retiro',
          'edit': 'Editar método de retiro',
          'delete': {
            'title': 'Confirmación de eliminación',
            'content': '¿Está seguro de que desea eliminar este método de retiro?'
          }
        },
        'form': {
          'defaultAmountInListError': 'Con monto fijo, el monto predeterminado debe estar incluido en la lista de montos',
          'amountListFormatError': 'Formato incorrecto, use solo números separados por comas, por ejemplo: 100,200,500',
          'defaultAmountPlaceholder': 'Ingrese el monto predeterminado',
          'defaultAmount': 'Monto Predeterminado',
          'amountListTooltip': 'Separe varios montos con comas, por ejemplo: 100,200,500,1000',
          'amountListPlaceholder': 'Ingrese la lista de montos, por ejemplo: 100,200,500,1000',
          'amountList': 'Lista de Montos',
          'amountTypeInput': 'Monto Ingresado',
          'amountTypeFixed': 'Monto Fijo',
          'amountTypeAll': 'Todos Soportados',
          'amountTypePlaceholder': 'Seleccione el tipo de monto',
          'amountType': 'Tipo de Monto',
          'typeName': 'Nombre de tipo',
          'typeNamePlaceholder': 'Ingrese nombre de tipo',
          'showName': 'Nombre de visualización',
          'showNamePlaceholder': 'Ingrese nombre de visualización',
          'showRemark': 'Observación de visualización',
          'showRemarkPlaceholder': 'Ingrese observación de visualización',
          'curSign': 'Moneda',
          'curSignPlaceholder': 'Seleccione moneda',
          'minAmount': 'Monto mínimo',
          'minAmountPlaceholder': 'Ingrese monto mínimo',
          'maxAmount': 'Monto máximo',
          'maxAmountPlaceholder': 'Ingrese monto máximo',
          'overAmount': 'Monto excedido',
          'overAmountPlaceholder': 'Ingrese monto excedido',
          'fee': 'Comisión',
          'feePlaceholder': 'Ingrese comisión',
          'sort': 'Ordenar',
          'sortPlaceholder': 'Ingrese orden',
          'pcImg': 'Imagen de PC',
          'h5Img': 'Imagen de H5'
        },
        'message': {
          'fetchFailed': 'Error al obtener datos',
          'addSuccess': 'Añadido exitosamente',
          'addFailed': 'Error al añadir',
          'editSuccess': 'Editado exitosamente',
          'editFailed': 'Error al editar',
          'deleteSuccess': 'Eliminado exitosamente',
          'deleteFailed': 'Error al eliminar',
          'enableSuccess': 'Habilitado exitosamente',
          'enableFailed': 'Error al habilitar',
          'disableSuccess': 'Deshabilitado exitosamente',
          'disableFailed': 'Error al deshabilitar'
        },
        'button': {
          'edit': 'Editar',
          'delete': 'Eliminar'
        }
      },
      'bankSettings': {
        'title': 'Configuración de banco',
        'search': {
          'bankShortName': 'Abreviatura de banco',
          'bankShortNamePlaceholder': 'p. ej. BPI / BDO',
          'bankFullName': 'Nombre completo del banco',
          'bankFullNamePlaceholder': 'p. ej. Bank of the Philippine Islands',
          'curSign': 'Moneda',
          'curSignPlaceholder': 'Seleccione moneda',
          'status': 'Estado',
          'statusPlaceholder': 'Seleccione estado',
          'button': 'Buscar',
          'reset': 'Restablecer'
        },
        'table': {
          'bankShortName': 'Abreviatura de banco',
          'bankFullName': 'Nombre completo del banco',
          'curSign': 'Moneda',
          'status': 'Estado',
          'action': 'Acción'
        },
        'button': {
          'add': 'Añadir',
          'edit': 'Editar',
          'delete': 'Eliminar',
          'channelMapping': 'Configuración de mapeo de canal'
        },
        'form': {
          'bankShortName': 'Abreviatura de banco',
          'bankShortNamePlaceholder': 'Ingrese abreviatura de banco',
          'bankFullName': 'Nombre completo del banco',
          'bankFullNamePlaceholder': 'Ingrese nombre completo del banco',
          'curSign': 'Moneda',
          'curSignPlaceholder': 'Seleccione moneda'
        },
        'modal': {
          'add': 'Añadir información de banco',
          'edit': 'Editar información de banco',
          'delete': {
            'title': 'Confirmar eliminación',
            'content': '¿Está seguro de que desea eliminar esta información de banco?'
          },
          'channelMapping': 'Configuración de mapeo de canal'
        },
        'message': {
          'fetchFailed': 'Error al obtener datos',
          'createSuccess': 'Creado exitosamente',
          'createFailed': 'Error al crear',
          'updateSuccess': 'Actualizado exitosamente',
          'updateFailed': 'Error al actualizar',
          'deleteSuccess': 'Eliminado exitosamente',
          'deleteFailed': 'Error al eliminar',
          'enableSuccess': 'Habilitado exitosamente',
          'enableFailed': 'Error al habilitar',
          'disableSuccess': 'Deshabilitado exitosamente',
          'disableFailed': 'Error al deshabilitar',
          'operationFailed': 'Operación fallida, intente de nuevo',
          'channelMappingComingSoon': 'La función de configuración de mapeo de canal está en desarrollo',
          'fetchChannelMappingFailed': 'Error al obtener configuración de mapeo de canal',
          'channelMappingSaveSuccess': 'Configuración de mapeo de canal guardada exitosamente',
          'channelMappingSaveFailed': 'Error al guardar configuración de mapeo de canal',
          'bankInfoIdRequired': 'Se requiere ID de información de banco',
          '70023003': 'Abreviatura de banco ya existe, no se puede añadir banco con abreviatura duplicada',
          '70023004': 'Nombre completo del banco ya existe, no se puede añadir banco con nombre duplicado',
          '70023005': 'Nombre de banco ya existe, no se puede añadir banco con nombre duplicado'
        },
        'channelMapping': {
          'paymentChannel': 'Canal de pago',
          'channelName': 'Nombre del canal',
          'bankCode': 'Código de pago (BankCode pasado a canal)',
          'bankCodePlaceholder': 'p. ej.: PH_AUB / 161319 / BC00007',
          'notSupported': '(No admitido)',
          'description': 'Descripción: Cuando el sistema realiza un pago, buscará el código de pago configurado aquí según "Abreviatura de banco + Canal de pago" y lo pasará al canal de terceros. BankCode vacío significa que el canal no es admitido.'
        }
      },
      'paidChannel': {
        'title': 'Configuración de canal pagado',
        'search': {
          'channelName': 'Nombre del canal',
          'channelNamePlaceholder': 'Ingrese nombre del canal',
          'channelType': 'Tipo de canal',
          'channelTypePlaceholder': 'Seleccione tipo de canal',
          'curSign': 'Moneda',
          'curSignPlaceholder': 'Seleccione moneda',
          'status': 'Estado',
          'statusPlaceholder': 'Seleccione estado',
          'statusAll': 'Todo',
          'statusEnabled': 'Habilitado',
          'statusDisabled': 'Deshabilitado',
          'button': 'Buscar',
          'reset': 'Restablecer'
        },
        'table': {
          'channelName': 'Nombre del canal',
          'componentName': 'Canal de pago',
          'channelType': 'Método de retiro',
          'curSign': 'Moneda',
          'minAmount': 'Monto mínimo',
          'maxAmount': 'Monto máximo',
          'fee': 'Comisión',
          'status': 'Estado',
          'updateInfo': 'Información de actualización',
          'action': 'Acción'
        },
        'modal': {
          'add': 'Añadir canal pagado',
          'edit': 'Editar canal pagado',
          'delete': {
            'title': 'Confirmar eliminación',
            'content': '¿Está seguro de que desea eliminar este canal pagado?'
          },
          'param': {
            'title': 'Configuración de parámetros de {{channelName}}',
            'cancel': 'Cancelar',
            'save': 'Guardar',
            'noParams': 'Sin configuración de parámetros disponible',
            'inputPlaceholder': 'Ingrese {{key}}'
          }
        },
        'form': {
          'channelName': 'Nombre del canal',
          'channelNamePlaceholder': 'Ingrese nombre del canal',
          'componentName': 'Nombre del componente',
          'componentNamePlaceholder': 'Seleccione componente',
          'channelType': 'Tipo de canal',
          'channelTypePlaceholder': 'Seleccione tipo de canal',
          'curSign': 'Moneda',
          'curSignPlaceholder': 'Seleccione moneda',
          'minAmount': 'Monto mínimo',
          'minAmountPlaceholder': 'Ingrese monto mínimo',
          'maxAmount': 'Monto máximo',
          'maxAmountPlaceholder': 'Ingrese monto máximo',
          'fee': 'Comisión',
          'feePlaceholder': 'Ingrese comisión'
        },
        'message': {
          'fetchFailed': 'Error al obtener datos',
          'addSuccess': 'Añadido exitosamente',
          'addFailed': 'Error al añadir',
          'editSuccess': 'Editado exitosamente',
          'editFailed': 'Error al editar',
          'deleteSuccess': 'Eliminado exitosamente',
          'deleteFailed': 'Error al eliminar',
          'enableSuccess': 'Habilitado exitosamente',
          'enableFailed': 'Error al habilitar',
          'disableSuccess': 'Deshabilitado exitosamente',
          'disableFailed': 'Error al deshabilitar',
          'paramSaveSuccess': 'Parámetros guardados exitosamente',
          'paramSaveFailed': 'Error al guardar parámetros'
        },
        'button': {
          'add': 'Añadir',
          'edit': 'Editar',
          'delete': 'Eliminar',
          'param': 'Parámetros'
        }
      }
    },
    'riskWithdrawConfig': {
      'title': 'Configuración de retiro de riesgo',
      'section': {
        'currencyConfig': 'Configuración de moneda'
      },
      'status': {
        'enabled': 'Habilitado',
        'disabled': 'Deshabilitado'
      },
      'button': {
        'save': 'Guardar'
      },
      'input': {
        'placeholder': 'Ingrese umbral'
      },
      'message': {
        'fetchFailed': 'Error al obtener lista de configuración',
        'editSuccess': 'Guardado exitosamente',
        'editFailed': 'Error al guardar'
      },
      'configGroup': {
        'netAmount': 'Monto neto (monto fijo)',
        'netPercent': 'Monto neto (porcentaje)',
        'winLost': 'Ganancia/Pérdida del usuario',
        'withdrawAmount': 'Monto de retiro',
        'bonusPercent': 'Porcentaje de bono',
        'bonusAmount':'Monto de bono',
        'riskModel': 'Modo de control de riesgo',
        'riskRule': 'Regla de monto de retiro',
        'bonusSection': 'Bono',
        'arbitrageSection': 'Riesgo de arbitraje de juego'
      },
      'sectionTitle': {
        netDiff: '1) Diferencia neta depósito-retiro (Fijo + Porcentaje)',
        userWinLost: '1.2 Ganancia/Pérdida del usuario (Opcional)',
        withdrawAmountRule: '1.3 Regla de monto de retiro (Rango VIP, VIP0=No miembro)',
        bonus: '2) Bono (Regla independiente)',
        arbitrage: '3) Riesgo de arbitraje de juego (Activado→Revisión manual)',
        noDeposit: 'Usuario sin depósito sospechoso de arbitraje',
        initDeposit: 'Primer depósito sospechoso de arbitraje',
        deviceIP: 'Múltiples cuentas en mismo dispositivo/IP sospechoso de arbitraje'
      },
      'riskRuleFields': {
        vipMin: 'VIP mínimo',
        vipMax: 'VIP máximo',
        successWithdraw: 'Retiro exitoso=0',
        successWithdrawStatus: 'Estado',
        successTopUp: 'Recarga exitosa=0',
        successTopUpStatus: 'Estado',
        successDeposit: 'Depósito exitoso>0',
        successDepositStatus: 'Estado',
        totalX: 'Total diario X',
        totalY: 'Total diario Y',
        totalZ: 'Total diario Z'
      },
      'arbitrageFields': {
        balance: 'Saldo',
        profitRisk: '% de ganancia de alto riesgo',
        deposit: 'Monto de apuesta',
        historyNum: 'Número de depósitos históricos',
        balanceDepositMul: 'Múltiplo saldo/depósito',
        depoistStart: 'Inicio de rango de depósito',
        depoistEnd: 'Fin de rango de depósito',
        deviceStart: 'Inicio de rango de dispositivo',
        deviceEnd: 'Fin de rango de dispositivo',
        iPStart: 'Inicio de rango de IP',
        iPEnd: 'Fin de rango de IP'
      },
      'riskModel': {
        'auto': 'Revisión automática',
        'manual': 'Revisión manual'
      },
      'globeStatus': {
        enabled: 'Habilitado',
        disabled: 'Deshabilitado'
      },
      'descriptions': {
        'netAmount': 'Diferencia total de depósito y retiro = retiro total - depósito total<br/>Porcentaje de diferencia depósito/retiro = retiro total / depósito total * 100%<br/>Cuando la diferencia depósito/retiro del usuario actual es mayor al valor establecido y ambas condiciones se cumplen simultáneamente, entra a aprobación manual',
        'netPercent': 'Diferencia total de depósito y retiro = retiro total - depósito total<br/>Porcentaje de diferencia depósito/retiro = retiro total / depósito total * 100%<br/>Cuando la diferencia depósito/retiro del usuario actual es mayor al valor establecido y ambas condiciones se cumplen simultáneamente, entra a aprobación manual',
        'winLost': 'Ganancia/pérdida del usuario = valor de ganancia/pérdida acumulada del usuario. Si es positivo, significa que el usuario es rentable.<br/>Cuando la ganancia/pérdida del usuario excede el valor establecido, entra a revisión manual.',
        'withdrawAmount': 'Cuando monto de retiro = valor absoluto del monto de retiro esta vez, cuando el monto de retiro del usuario actual es mayor al valor establecido, entra a revisión manual',
        'bonusPercent': 'Ratio de descuento total = descuento total recibido / monto de depósito total * 100%<br/>Monto de descuento total = valor absoluto de descuento recibido<br/>Cuando el valor absoluto del monto total de descuento del usuario actual es mayor al valor establecido y ambas condiciones se cumplen simultáneamente, entra a revisión manual',
        'bonusAmount': 'Ratio de descuento total = descuento total recibido / monto de depósito total * 100%<br/>Monto de descuento total = valor absoluto de descuento recibido<br/>Cuando el valor absoluto del monto total de descuento del usuario actual es mayor al valor establecido y ambas condiciones se cumplen simultáneamente, entra a revisión manual',
        'riskModel': ''
      },
      addRange: 'Agregar Rango',
      delete: 'Eliminar',
      ruleHitDesc: 'Cuando se activa cualquier regla habilitada → retiro entra a [Revisión Manual].',
      hintPrefix: 'Pista: ',
      autoHintDescBody: 'Órdenes de retiro que activen cualquiera de las siguientes reglas entrarán a [Revisión Manual]; de lo contrario, se aplica revisión automática.',
      autoHintDesc: 'Pista: Órdenes de retiro que activen cualquiera de las siguientes reglas entrarán a [Revisión Manual]; de lo contrario, se aplica revisión automática.',
      balanceCalPrefix: 'Saldo de riesgo (calibre de riesgo de retiro): ',
      balanceCalBody: 'Saldo de cuenta + monto de retiro actual + órdenes de retiro pendientes + monto de apuesta no liquidada.',
      balanceCalDesc: 'Saldo de riesgo (calibre de riesgo de retiro): Saldo de cuenta + monto de retiro actual + órdenes de retiro pendientes + monto de apuesta no liquidada.',
      hitRuleTitle: '1) Reglas de Activación de Retiro',
      tableRuleName: 'Nombre de Regla',
      tableCondition: 'Condición',
      tableThreshold: 'Umbral',
      tableStatus: 'Estado',
      tableConfig: 'Configuración',
      netDiffCondition: 'Diferencia neta = retiro total - depósito total ≥ umbral fijo; y % diferencia neta ≥ % umbral (cuando ambos estén habilitados).',
      netDiffRowName: 'Diferencia neta depósito-retiro (fija / porcentaje)',
      fixedAmountLabel: 'Monto fijo ≥',
      percentLabel: 'Porcentaje ≥',
      winLostRowName: 'Umbral de ganancia/pérdida acumulada del usuario',
      winLostCondition: 'Ganancia/pérdida acumulada del usuario (o neta) alcanza el umbral.',
      bonusRowName: 'Anomalía de bonificación (ratio / monto)',
      bonusCondition: 'Tanto el ratio de bonificación total como el monto de bonificación total ≥ umbral.',
      bonusPercentLabel: 'Ratio de bonificación ≥',
      bonusAmountLabel: 'Monto de bonificación ≥',
      vipRangeHint: 'Rango: vip_min ≤ nivel VIP ≤ vip_max; sin solapamiento; ascendente por vip_min. (ej. 0-0 no miembro; 1-3 / 4-6 / 7-10)',
      noHistoryWithdraw: 'Sin historial de retiro',
      noHistoryDeposit: 'Sin historial de depósito',
      hasDepositRecord: 'Tiene registro de depósito',
      dailyThresholdXYZ: 'Total diario (X/Y/Z)',
      noDepositMuted: 'Recuento de depósito del historial=0; ganancia neta negativa no activa.',
      deviceIPMuted: 'El rango admite 0-0 sin límite; Y ≥ X.',
      sectionTitleNetDiffSub: '1.1 Diferencia Neta Depósito-Retiro (Monto Fijo + Porcentaje)',
      sectionTitleUserWinLostSub: '1.2 Ganancia/Pérdida del Usuario (Opcional)',
      sectionTitleWithdrawAmountRuleSub: '1.3 Regla de Monto de Retiro (Rango VIP Configurable, VIP0=No miembro)',
      sectionTitleBonusSub: '2) Bonificación (Regla Independiente)',
      sectionTitleArbitrageSub: '3) Riesgo de Arbitraje de Juego (Activación→Revisión Manual)',
      netDiffRuleDef: 'Regla: <b>Diferencia neta = Retiro total - Depósito total</b>; <b>% diferencia neta = (Retiro total / Depósito total) × 100%</b>.<br />',
      netDiffHitLogic: 'Lógica de activación: Diferencia neta del usuario <b>≥</b> umbral; cuando tanto monto fijo como porcentaje están habilitados, <b>ambos deben cumplirse (AND)</b> para activar revisión manual.',
      statusEnabled: 'Habilitado',
      statusOpen: 'Activado',
      operation: 'Acción',
      vipRangeIntro: 'Configurar por "rango de nivel VIP": ',
      vipRangeIntroBold: 'vip_min=0 y vip_max=0 significa no miembro.',
      riskRuleHitDesc: 'Cualquier condición [habilitada] en el rango (OR) → Revisión manual.',
      vipRangeLabel: 'Rango de Nivel VIP',
      singleWithdrawThreshold: 'Umbral de Retiro Único (X)',
      bonusRuleDef: 'Regla: ',
      bonusRuleDefPart1: '<b>% bonificación total = (Bonificación total recibida / Depósito total) × 100%</b>; ',
      bonusRuleDefPart2: '<b>Monto de bonificación total = Valor absoluto de bonificación recibida</b>.<br />',
      bonusHitLogic: 'Lógica de activación: Tanto bonificación total (valor absoluto) como % bonificación del usuario <b>≥</b> umbral; ambos deben cumplirse (AND) para revisión manual.',
      tableNote: 'Nota',
      depositRange: 'Rango de Recuento de Depósitos',
      deviceRange: 'Rango de Recuento de Dispositivos Registrados',
      ipRange: 'Rango de Recuento de IPs Registradas',
      balanceGt: 'Saldo de Control de Riesgo >',
      profitRiskGt: '% de Ganancia Alto Riesgo >',
      depositLt: 'Monto de Apuesta <',
      historyNumLt: 'Recuento de Depósito del Historial <',
      balanceDepositMulGt: 'Múltiple Saldo de Control de Riesgo/Depósito >',
      saveConfig: 'Guardar Configuración'
    }
  },

  // Add manualBalance translations
  'manualBalance': {
    'title': 'Registros de Ajuste de Miembros',
    'dateRange': 'Hora de Ajuste',
    'startDate': 'Fecha de Inicio',
    'endDate': 'Fecha de Finalización',
    'dateRangeExceeded': 'El rango de tiempo de consulta no puede exceder {days} días',
    'memberAccount': 'Cuenta de Miembro',
    'enterMemberAccount': 'Ingrese la cuenta de miembro',
    'transNo': 'Número de Orden',
    'enterTransNo': 'Ingrese el número de orden',
    'subType': 'Tipo de Ajuste',
    'selectSubType': 'Seleccione el tipo de ajuste',
    'manualIn': 'Depósito Manual',
    'manualOut': 'Retiro Manual',
    'manualInNotIncludeOrder': 'Depósito Manual Sin Incluir Orden',
    'manualOutNotIncludeOrder': 'Retiro Manual Sin Incluir Orden',
    'badDebtOrder': 'Orden de Deuda Incobrable',
    'agentIn': 'Depósito de Agente',
    'agentOut': 'Transferencia de Agente',
    'curSign': 'Moneda',
    'selectCurrency': 'Seleccione la moneda',
    'search': 'Buscar',
    'reset': 'Restablecer',
    'agentLine': 'Línea de Agente',
    'unknownType': 'Tipo Desconocido',
    'amount': 'Monto de Ajuste',
    'method': 'Método',
    'included': 'Incluido',
    'notIncluded': 'No Incluido',
    'remark': 'Comentario',
    'beforeAmount': 'Saldo Anterior',
    'afterAmount': 'Saldo Posterior',
    'externalBetflow': 'Monto de Flujo',
    'createUser': 'Operador',
    'enterCreateUser': 'Ingrese el operador',
    'export': 'Exportar',
    'exportLoading': 'Generando archivo de exportación, espere...',
    'exportSuccess': 'Tarea de exportación enviada, verifique la lista de descargas',
    'createUserAndTime': 'Operador/Hora',
    'totalCount': 'Recuento Total',
    'totalAmount': 'Monto Total'
  }
};
